module.exports = __webpack_public_path__ + "static/media/HSP70_initial_sequences.a7c7ec7b.zip";